/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Fee agreement type
 * @export
 */
export const FeeType = {
    Percentage: 'percentage',
    FlatFee: 'flat_fee'
} as const;
export type FeeType = typeof FeeType[keyof typeof FeeType];


export function instanceOfFeeType(value: any): boolean {
    for (const key in FeeType) {
        if (Object.prototype.hasOwnProperty.call(FeeType, key)) {
            if (FeeType[key as keyof typeof FeeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FeeTypeFromJSON(json: any): FeeType {
    return FeeTypeFromJSONTyped(json, false);
}

export function FeeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeeType {
    return json as FeeType;
}

export function FeeTypeToJSON(value?: FeeType | null): any {
    return value as any;
}

export function FeeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FeeType {
    return value as FeeType;
}

